module.exports = __webpack_public_path__ + "img/qrcode.77af51b8.png";